import api from "./index"

export async function getCabBookings({
  offset = 0,
  limit = 10,
  search = "",
  order_status,
} = {}) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      offset,
      limit,
      search,
      order_status,
    },
  }
  return api.get("/v1/orders", config)
}

export async function getCabBookingById(id) {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  }
  return api.get(`/v1/orders/${id}`, config)
}

export async function deleteCabBooking(id) {
  return api.delete(`/v1/orders/${id}`)
}

export async function rejectCabBooking(id) {
  const data = {
    order_status: 2, // 2 for rejected status
  }
  return api.put(`/v1/orders/${id}`, data)
}
